import API from "./api";

const AttendanceService = {
    // ============ ADMIN FUNCTIONS ============

    // Get all batches for dropdown
    getBatches: async () => {
        try {
            const response = await API.get("/attendance/batches");
            return response.data;
        } catch (error) {
            console.error("Error fetching batches:", error);
            throw error;
        }
    },

    // Get students in a batch
    getBatchStudents: async (batchId) => {
        try {
            const response = await API.get(`/attendance/batch/${batchId}/students`);
            return response.data;
        } catch (error) {
            console.error("Error fetching batch students:", error);
            throw error;
        }
    },

    // Get attendance for specific batch and date
    getAttendanceByDate: async (batchId, date) => {
        try {
            const response = await API.get(`/attendance/batch/${batchId}/date/${date}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching attendance:", error);
            throw error;
        }
    },

    // Save attendance records
    saveAttendance: async (batchId, date, attendanceData) => {
        try {
            const response = await API.post("/attendance/save", {
                batch_id: parseInt(batchId),
                date: date,
                attendance: attendanceData
            });
            return response.data;
        } catch (error) {
            console.error("Error saving attendance:", error);
            throw error;
        }
    },

    // Get student attendance calendar data
    getStudentCalendar: async (studentId, batchId, year, month) => {
        try {
            const response = await API.get(`/attendance/student/${studentId}/batch/${batchId}/calendar`, {
                params: { year, month }
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching calendar data:", error);
            throw error;
        }
    },

    // Export attendance to CSV
    exportAttendance: async (batchId) => {
        try {
            const response = await API.get(`/attendance/export/batch/${batchId}`, {
                responseType: 'blob'
            });
            
            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `attendance_${batchId}_${new Date().toISOString().split('T')[0]}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            
            return { success: true };
        } catch (error) {
            console.error("Error exporting attendance:", error);
            throw error;
        }
    }
};

export default AttendanceService;